export const config = {
  BASE_URL: '@@APP_API_BASE_URL'
};
